import BackCatalogDisclaimerModal from './BackCatalogDisclaimerModal';

export default BackCatalogDisclaimerModal;
